{
  "account": {
    "addEscrow": {
      "availableAmount": "Disponible:",
      "confirmDelegatingToInactive": {
        "description": "El estado de este validador es {{validatorStatus}}. Es posible que tu delegación no genere ninguna recompensa.",
        "title": "¿Estás seguro de que quieres continuar?"
      },
      "confirmDelegatingToTop": {
        "acknowledge": "Delegar de todos modos"
      },
      "delegate": "Delegar"
    },
    "loading": "Cargando cuenta",
    "loadingError": "No se pudo cargar la cuenta.",
    "reclaimEscrow": {
      "reclaim": "Reclamar",
      "reclaimableAmount": "Disponible:"
    },
    "sendTransaction": {
      "confirmSendingToValidator": {
        "title": "¿Estás seguro de que quieres continuar?"
      },
      "enterAddress": "Introduce una dirección",
      "recipient": "Destinatario",
      "send": "Enviar",
      "success": "Transacción enviada con éxito. La transacción puede tardar hasta un minuto en aparecer en tu cuenta."
    },
    "subnavigation": {
      "activeDelegations": "Delegaciones activas"
    },
    "summary": {
      "balance": {
        "available": "Disponible",
        "total": "Saldo total"
      },
      "noTransactionFound": "No se han encontrado transacciones.",
      "notYourAccount": "Esta no es tu cuenta."
    },
    "transaction": {
      "genericTransaction": {
        "destination": "Otra dirección"
      },
      "loadingError": "No se ha podido cargar las transacciones.",
      "reclaimEscrow": {
        "received": "<Amount/> reclamado por el delegador"
      },
      "transfer": {
        "received": "Recibido <Amount/>",
        "sent": {
          "header": "Enviado <Amount/>"
        }
      },
      "unrecognizedTransaction": {
        "destination": "Otra dirección",
        "header": "Transacción no reconocida '{{method}}'"
      }
    },
    "validator": {
      "loadingError": "No se han podido cargar los validadores."
    }
  },
  "backends": {
    "oasisscan": "API de Oasis Scan"
  },
  "common": {
    "amount": "Cantidad",
    "block": "Bloque",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "delegator": "Delegador",
    "from": "De",
    "to": "A",
    "unavailable": "No disponible",
    "validator": "Validador",
    "validators": "Validadores"
  },
  "createWallet": {
    "confirmSaved": "He guardado mi frase semilla",
    "doNotShare": "Nunca compartas tu frase semilla, cualquiera con tu frase semilla puede acceder a tu billetera y tus tokens.",
    "instruction": "Guarda tu frase semilla <strong>en el orden correcto</strong> en un lugar seguro, la necesitarás para abrir tu billetera.",
    "mnemonicMismatch": "La frase semilla introducida no coincide.",
    "newMnemonic": "Generar una frase semilla nueva",
    "thisIsYourPhrase": "Esta es tu frase semilla."
  },
  "delegations": {
    "activeDelegations": "Delegaciones activas",
    "delegatedAmount": "Cantidad delegada"
  },
  "errors": {
    "LedgerOasisAppIsNotOpen": "La aplicación de Oasis en Ledger está cerrada.",
    "cannotSendToSelf": "No puedes enviarte a ti mismo",
    "disconnectedError": "Se ha perdido la conexión.",
    "duplicateTransaction": "Transacción duplicada",
    "insufficientBalance": "Saldo insuficiente",
    "invalidAddress": "Dirección inválida",
    "invalidNonce": "Nonce inválido (número de transacción)",
    "invalidPrivateKey": "Clave privada inválida",
    "unknown": "Error desconocido: {{message}}",
    "unknownGrpc": "Error gRPC desconocido: {{message}}",
    "usbTransportNotSupported": "Tu navegador no es compatible con WebUSB ( por ejemplo, Firefox). Intenta utilizar Chrome."
  },
  "fatalError": {
    "copied": "Error copiado al portapapeles",
    "copy": "Copiar error al portapapeles"
  },
  "footer": {
    "terms": "<TermsLink>Condiciones generales</TermsLink>"
  },
  "home": {
    "create": {
      "button": "Crear billetera",
      "header": "Crear una billetera nueva"
    },
    "existing": {
      "button": "Abrir billetera",
      "header": "Acceder a una billetera existente"
    }
  },
  "icons": {
    "mnemonic": "Frase semilla",
    "privateKey": "Clave privada",
    "wallet": {
      "label": "Billetera"
    }
  },
  "ledger": {
    "instructionSteps": {
      "connectUsbLedger": "Conecta tu dispositivo USB Ledger al equipo",
      "header": "Pasos:",
      "openOasisApp": "Abre la aplicación de Oasis en tu dispositivo Ledger"
    },
    "steps": {
      "loadingAccounts": "Cargando los datos de la cuenta",
      "loadingBalances": "Cargando detalles del saldo",
      "openingUsb": "Abriendo Ledger a través de USB"
    }
  },
  "menu": {
    "closeWallet": "Cerrar billetera",
    "home": "Inicio",
    "wallet": "Billetera"
  },
  "openWallet": {
    "header": "¿Cómo quieres abrir tu billetera?",
    "ledger": {
      "header": "Abrir desde dispositivo Ledger"
    },
    "method": {
      "ledger": "Ledger",
      "mnemonic": "Frase semilla",
      "privateKey": "Clave privada"
    },
    "mnemonic": {
      "enterPhraseHere": "Introduce aquí tu frase semilla",
      "error": "Frase semilla inválida. Por favor, asegúrate de introducir las palabras en el orden correcto, todas en minúsculas.",
      "header": "Introduce tu frase semilla",
      "import": "Importar mi billetera",
      "instruction": "A continuación, introduce todas las palabras de tu frase semilla separadas por espacios. La mayoría de las frases semilla se componen de 24 o 12 palabras."
    },
    "privateKey": {
      "enterPrivateKeyHere": "Introduce aquí tu clave privada",
      "error": "Clave privada inválida",
      "header": "Introduce tu clave privada",
      "hidePrivateKey": "Ocultar la clave privada",
      "instruction": "Introduce tu clave privada en formato Base64.",
      "showPrivateKey": "Mostrar la clave privada"
    }
  },
  "paraTimes": {
    "amount": {
      "available": "Disponible:"
    }
  },
  "theme": {
    "darkMode": "Modo oscuro",
    "lightMode": "Modo claro"
  },
  "toolbar": {
    "networks": {
      "local": "Local",
      "mainnet": "Mainnet",
      "testnet": "Testnet"
    },
    "wallets": {
      "type": {
        "mnemonic": "Frase semilla",
        "privateKey": "Clave privada"
      }
    }
  },
  "transaction": {
    "confirm": "Confirmar",
    "preview": {
      "amount": "Cantidad",
      "from": "De",
      "gas": "Gas",
      "to": "A",
      "type": "Tipo",
      "validator": "Validador",
      "warning": "Una vez que confirmes la transacción, no podrás cancelarla. Revísala cuidadosamente y confirma una vez que estés seguro de que quieres enviarla."
    },
    "step": {
      "signing": "Firmando la transacción",
      "submitting": "Enviando la transacción"
    },
    "types": {
      "addEscrow": "delegando tus tokens a un validador para generar recompensas"
    }
  },
  "validator": {
    "commission": "Comisión",
    "commissionBounds": {
      "label": "Límites de comisión"
    },
    "name": "Nombre",
    "status": "Estado",
    "statusActive": "Activo",
    "statusInactive": "Inactivo",
    "statusUnknown": "Desconocido",
    "unknownValidator": "Validador desconocido"
  }
}
